import { createUseTableData } from '@akyga/shared-ui/useTableData';
import httpClient from 'API/httpClient';

export default createUseTableData(httpClient);
